import { render, staticRenderFns } from "./Hutang.vue?vue&type=template&id=280c9416&"
import script from "./Hutang.vue?vue&type=script&lang=js&"
export * from "./Hutang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Hutang.vue"
export default component.exports